import { InboxView, ThreadReadStatus } from '@weave/schema-gen-ts/dist/schemas/sms/data/v4/sms_service.pb';
import { SchemaQuery } from '@frontend/react-query-helpers';
import { CountThreadsStatusUpdate } from '../../../types';
import { ServiceQueries } from '../../types';

export const getAffectedCountThreadsPredicate =
  ({
    newStatus,
    locationId,
  }: {
    newStatus: CountThreadsStatusUpdate;
    locationId: string;
  }): ((query: SchemaQuery<ServiceQueries, 'CountThreads', false, unknown>) => boolean) =>
  ({ queryKey }) => {
    const request = queryKey[2];
    const readStatusesInFilter = request.filter?.statuses?.filter((status) =>
      [ThreadReadStatus.READ, ThreadReadStatus.NEW, ThreadReadStatus.ERROR].includes(status)
    );
    if (!request.locationIds?.includes(locationId)) return false;
    switch (newStatus) {
      case 'actionable':
      case 'not-actionable':
        return request.filter?.inboxView === InboxView.ACTIONABLE;
      case 'read':
      case 'unread':
      case 'error':
        return readStatusesInFilter?.length === 1;
    }
  };
